import {BaseComponent} from './baseComponent';
import {match} from 'react-router';
import {Translate} from '../services/translate';
import {lazyInject} from '../services/container';

export interface PageComponentProps<TMatch = {}>
{
    match: match<TMatch & { locale?: 'eng' }>;
}

export class PageComponent<TProps = {}, TState = {}> extends BaseComponent<TProps, TState>
{
    @lazyInject(Translate)
    protected translate: Translate;
    
    public constructor(props: TProps & PageComponentProps, context: any)
    {
        super(props, context);
        
        this.translate.setLanguage(props.match.params.locale === 'eng' ? 'en' : 'hu')
        
        console.log('match is', props.match);
    }
}